export enum Routes {
  // User routes
  Users = '/users',
  UserView = '/users/view/:id',
  UserChangePlan = '/users/plan/:accountId',
  CreateAdmin = '/users/create-admin',
  CreateTopUser = '/users/create-top-user',
  CreateTeam = '/users/create-team',
  CreateTeamSet = '/users/create-team-set',
  TeamView = '/users/teams/view/:id',
  TeamSetView = '/users/teams/sets/view/:id',

  // Facility routes
  Facilities = '/facilities',
  FacilityView = '/facilities/view/:facilityId',

  // Device routes
  Devices = '/devices',
  DeviceView = '/devices/view/:deviceId',
  DeviceUpdate = '/devices/update/:deviceId',
  DeviceSessionCreate = '/devices/sessions/create',
  DeviceSession = '/devices/sessions/:sessionId',
  DeviceSessionDevices = '/devices/sessions/:sessionId/devices',

  // Task routes
  TasksRoot = '/tasks',
  TasksBulkCreation = '/tasks/bulk-creation',

  // Work order routes
  WorkOrders = '/work-orders',
  WorkOrderAreas = '/work-orders/areas',
  BulkReportRepair = '/work-orders/bulk-report-repair',

  // Log routes
  LogsRoot = '/logs',
  LogsCompleted = '/logs/completed',
  LogTypes = '/logs/logtypes',

  // Analytics routes
  AnalyticsRoot = '/analytics',
  Analytics = '/analytics/:dashboardID',
}
